<template>
  <div class="time-size-page">
    <Header
      :leftArrow="true"
      :leftText="''"
      @leftClick="onClickLeft"
      :rightIcons="false"
    />
    <div class="mypage time-size-content" v-if="isReady">
      <div class="wrap mypage_wrap">
        <div class="time-size-intro">
          <p class="time-size-intro_title">待受画面時間表示の大きさの変更</p>
        </div>

        <ul class="mypage_sound-select time-size-options">
          <li
            v-for="option in sizeOptions"
            :key="option.value"
            class="mypage_setting-item time-size-option"
            @click="selectSize(option.value)"
          >
            <input
              :id="'time-size-' + option.value"
              :checked="timeShowFontSize === option.value"
              type="radio"
              name="time-size"
              @change="selectSize(option.value)"
            />
            <label :for="'time-size-' + option.value">
              <span class="time-size-option_label">{{ option.label }}</span>
            </label>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import { RefreshUserInfo } from "@/services/login";
import { GetUserDetails, UpdateUser } from "@/services/user";
import { Toast } from "vant";
import "vant/es/toast/style";

export default {
  components: {
    Header,
  },
  data() {
    return {
      isReady: false,
      isSaving: false,
      userInfo: {},
      timeShowFontSize: 2,
      sizeOptions: [
        { value: 1, label: "標準" },
        { value: 2, label: "大" },
        { value: 3, label: "極大" },
      ],
    };
  },
  mounted() {
    this.initUserInfo();
  },
  methods: {
    async initUserInfo() {
      const res = await GetUserDetails();
      this.userInfo = res.data.data.detail;
      this.timeShowFontSize = Number(this.userInfo.time_show_font_size) || 2;
      this.isReady = true;
    },
    async selectSize(value) {
      if (this.isSaving || this.timeShowFontSize === value) {
        return;
      }

      const previousValue = this.timeShowFontSize;
      this.timeShowFontSize = value;
      this.isSaving = true;

      try {
        const res = await UpdateUser({
          id: this.userInfo.id,
          time_show_font_size: value,
        });

        if (res.data.code < 0) {
          this.timeShowFontSize = previousValue;
          Toast.fail("変更に失敗しました");
          return;
        }

        const refreshRes = await RefreshUserInfo();
        const user = refreshRes.data.data.user;
        localStorage.setItem(process.env.VUE_APP_USER_KEY, JSON.stringify(user));
        this.userInfo = {
          ...this.userInfo,
          time_show_font_size: value,
        };
        Toast.success("変更に成功しました");
      } catch (error) {
        this.timeShowFontSize = previousValue;
        Toast.fail("変更に失敗しました");
      } finally {
        this.isSaving = false;
      }
    },
    onClickLeft() {
      history.back();
    },
  },
};
</script>

<style scoped>
.time-size-page {
  min-height: 100vh;
  background: #f4fbff;
}

.time-size-content {
  min-height: calc(100vh - 46px);
}

.time-size-intro {
  margin-bottom: 20px;
}

.time-size-intro_title {
  color: #1c1f21;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.5;
}

.time-size-options {
  margin: 0;
}

.time-size-option {
  cursor: pointer;
  padding: 18px 16px;
}

.time-size-option label {
  align-items: center;
  display: flex;
  min-height: 28px;
  padding-right: 8px;
}

.time-size-option_label {
  color: #1c1f21;
  display: block;
  font-size: 18px;
  font-weight: 700;
}
</style>
